import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { filter, map, Observable, shareReplay, Subscription } from 'rxjs';
import { PrimeNG } from 'primeng/config';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';
import { Call, EventDTO, Message } from './model';
import { RxStompService } from './socket';
import { isCallMessage, isEventMessage } from './guards/message-type-guards';
import { EventStore } from './components/event/event.store';
import { CallStore } from './components/call/call.store';

@Component({
  selector: 'pan-root',
  standalone: true,
  imports: [RouterOutlet, Toast, TranslateModule, ConfirmDialog],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  private rxStompService = inject(RxStompService);
  private eventStore = inject(EventStore);
  private callStore = inject(CallStore);
  private subscription = new Subscription();
  public$: Observable<Message> = this.rxStompService.watch('/public').pipe(
    map((response) => JSON.parse(response.body)),
    shareReplay()
  );

  constructor(private config: PrimeNG, private translate: TranslateService) {
    this.translate.addLangs(['sr']);
    this.translate.setDefaultLang('sr');
    this.translate.use('sr');
  }

  ngOnInit(): void {
    this.subscription.add(
      this.translate.get('primeng')
        .subscribe(res => this.config.setTranslation(res))
    );

    this.subscription.add(
      this.public$
        .pipe(
          filter(isEventMessage),
          map((msg) => msg.payload)
        )
        .subscribe({
          next: (msg: EventDTO) => this.eventStore.add(msg),
        })
    );

    this.subscription.add(
      this.public$
        .pipe(
          filter(isCallMessage),
          map((msg) => msg.payload)
        )
        .subscribe({
          next: (msg: Call) => this.callStore.add(msg),
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
